import { Outlet, useParams } from "react-router-dom";
import { StatusChip } from "@/shared/components/ui/status-chip";
import { PipelineTabs } from "./PipelineTabs";
import { findDemoCampaign } from "./demo-data";
import { useCampaignsList } from "./use-campaigns";

/**
 * Chrome shared by every campaign-scoped screen: breadcrumb + title + status
 * chip, then the pipeline tab bar, then the active tab's content (Outlet).
 *
 * The name/status come from the campaigns list cache (real data) when available,
 * falling back to the demo campaign, then the id — so opening a real campaign
 * shows its real name without an extra fetch.
 */
export function CampaignLayout() {
  const { id } = useParams<{ id: string }>();
  const { data } = useCampaignsList();

  const real = data?.find((c) => c.id === id);
  const demo = findDemoCampaign(id);
  const name = real?.name ?? demo?.name ?? id ?? "Campaign";
  const status = real?.status ?? demo?.status;

  return (
    <div>
      <p className="ge-eyebrow">CAMPAIGNS / {name.toUpperCase()}</p>
      <div className="mt-2 flex items-center gap-3">
        <h1 className="font-sans text-[24px] font-bold tracking-[-0.3px] text-ge-primary">
          {name}
        </h1>
        {status && (
          <StatusChip variant={status === "LAUNCHED" ? "positive" : "neutral"}>{status}</StatusChip>
        )}
      </div>

      {id && <PipelineTabs campaignId={id} />}

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
